<template>
  <div class="tabs-container flex items-center">
    <div
      v-for="(item, index) in tabs"
      :key="index"
      class="tabs-item flex items-center justify-center"
      :class="{ active: index === activeIndex }"
      @click="changeTab(index)"
    >
      <span>{{ item }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EditorTabs',
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    changeTab(index) {
      this.$emit('changeTab', index);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.tabs-container {
  .tabs-item {
    @apply relative cursor-pointer h-full font-medium;
    background-color: $page-bg-sub-color;
    color: $experience-tab-default-color;
    font-size: 16px;
    &:first-child {
      margin-right: 24px;
    }
    &.active {
      background-color: $page-bg-sub-color;
      span {
        background: linear-gradient(180deg, #e15d3f 0%, #febf5d 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      &::before {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: 2px;
        background: linear-gradient(270deg, #e15d3f 0%, #febf5d 100%);
      }
    }
  }
}
</style>
